<template>
  <v-app>
    <v-app-bar app color="primary" dark class="bg_toolbar" height="70px">
      <!-- <v-toolbar-title v-if="!mobile">
        <h2>ระบบฐานข้อมูลคำทับศัพท์ของสำนักงานราชบัณฑิตยสภา</h2>
      </v-toolbar-title>-->
      <v-toolbar-title>
        <h2 class="text-center">
          <v-icon class="mr-2 mb-2">mdi-cog</v-icon>ตั้งค่าระบบ
        </h2>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="goPage()">
        <v-icon>mdi-home</v-icon>
      </v-btn>
    </v-app-bar>

    <!-- <v-content> -->
    <router-view></router-view>

    <v-speed-dial v-if="current_path != '/setting'" color="pink" fab dark small fixed bottom right>
      <v-btn class="bg_btn_gradient" slot="activator" dark fab outlined>
        <v-icon>menu</v-icon>
      </v-btn>
      <v-tooltip left open-on-hover v-for="item in items" :key="item.path" v-if="item.permission">
        <template v-slot:activator="{ on }">
          <v-avatar
            v-on="on"
            @click="
              $router.push(item.path);
              fab = false;
            "
            color="white"
            class="elevation-2 mt-1 animate-fadeIn"
            size="50"
          >
            <v-avatar size="28" tile>
              <v-img :src="item.img"></v-img>
            </v-avatar>
          </v-avatar>
        </template>
        <span>{{ item.title }}</span>
      </v-tooltip>
    </v-speed-dial>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          th_title: "ตั้งค่า",
          title: "All Settings",
          img: require("../../assets/icon/setting.svg"),
          path: "/setting",
          permission: this.$session.get("permission_setting")
            ? this.$session.get("permission_setting").length > 0
              ? true
              : false
            : false,
        },
        {
          th_title: "ภาษา",
          title: "Language",
          text: "It's New Release Friday",
          subtext: "Newly released songs. Updated daily.",
          img: require("../../assets/icon/translation.svg"),
          path: "/setting/language",
          permission: this.$session.get("permission_setting")
            ? this.$session.get("permission_setting").includes("language")
            : false,
        },
        {
          th_title: "หมวดหมู่",
          title: "Category",
          img: require("../../assets/icon/category.svg"),
          path: "/setting/category",
          permission: this.$session.get("permission_setting")
            ? this.$session.get("permission_setting").includes("category")
            : false,
        },
        {
          th_title: "สิทธิ์การใช้งาน",
          title: "Permission",
          img: require("../../assets/icon/permission.svg"),
          path: "/setting/permission",
          permission: this.$session.get("permission_setting")
            ? this.$session.get("permission_setting").includes("permission")
            : false,
        },
      ],

      fab: false,
    };
  },

  computed: {
    current_path() {
      return this.$route.fullPath;
    },
    mobile() {
      if (
        this.$vuetify.breakpoint.width >= 320 &&
        this.$vuetify.breakpoint.width < 768
      ) {
        return true;
      } else {
        return false;
      }
    },
    tablet() {
      if (
        this.$vuetify.breakpoint.width >= 768 &&
        this.$vuetify.breakpoint.width < 1440
      ) {
        return true;
      } else {
        return false;
      }
    },
    desktop() {
      if (this.$vuetify.breakpoint.width >= 1440) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    goPage() {
      this.$router.push(process.env.VUE_APP_HOME);
    },
  },
};
</script>
